import React, { useState } from "react";
import { useLocalStorage } from "./hooks/useLocalStorage";

export const Collapsible = ({ header, children, isVisible = true, defaultOpen = false }) => {
  const [isOpen, setOpen] = useState(defaultOpen);
  const toggleOpen = () => setOpen(!isOpen);
  return CollapsibleView(isVisible, header, toggleOpen, isOpen, children);
};

export const CollapsiblePersistent = ({
  id,
  header,
  children,
  isVisible = true,
  className = "",
  defaultOpen = false,
}) => {
  const [isOpen, setOpen] = useLocalStorage(id, defaultOpen);
  const toggleOpen = () => setOpen(!isOpen);
  return CollapsibleView(isVisible, header, toggleOpen, isOpen, children, className);
};

const CollapsibleView = (isVisible, header, toggleOpen, isOpen, children, className) => {
  if (!isVisible) return null;

  return (
    <>
      {header ? header(toggleOpen, isOpen) : null}
      {isOpen && children ? <div className={className}>{children}</div> : null}
    </>
  );
};
